import React from 'react';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { Monitor, ShoppingBag, UtensilsCrossed, GraduationCap, Cpu, Briefcase, Heart, Wrench } from 'lucide-react';

const classes = [
  { icon: Monitor, classNum: '09', name: 'Technology & Electronics', examples: 'Software, apps, electronics, headphones' },
  { icon: ShoppingBag, classNum: '25', name: 'Clothing & Apparel', examples: 'T-shirts, shoes, hats, athletic wear' },
  { icon: Briefcase, classNum: '35', name: 'Business Services', examples: 'Advertising, consulting, retail stores' },
  { icon: UtensilsCrossed, classNum: '43', name: 'Food & Restaurant', examples: 'Restaurants, catering, cafes, trucks' },
  { icon: GraduationCap, classNum: '41', name: 'Education & Training', examples: 'Courses, coaching, seminars' },
  { icon: Cpu, classNum: '42', name: 'Software & IT', examples: 'SaaS, hosting, cloud services' },
  { icon: Heart, classNum: '44', name: 'Health & Beauty', examples: 'Skincare, supplements, wellness' },
  { icon: Wrench, classNum: '37', name: 'Construction & Repair', examples: 'Building, plumbing, HVAC' },
];

const TrademarkClassesSection = () => {
  const header = useScrollAnimation({ threshold: 0.15 });
  return (
    <section data-testid="trademark-classes-section" className="py-24 md:py-32 bg-[#041B1C] relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
        <div ref={header.ref} className={`text-center max-w-2xl mx-auto mb-16 scroll-fade-up ${header.isVisible ? 'scroll-visible' : ''}`}>
          <span className="inline-block bg-[#A5BF23]/10 text-[#A5BF23] px-4 py-1.5 rounded-full text-xs font-bold tracking-[0.2em] mb-4">TRADEMARK CLASSES</span>
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-[#F0F4F4] mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>Brand Name Filing Classes</h2>
          <p className="text-base text-[#A0B2B2] leading-relaxed">The USPTO uses 45 classes. Your brand name filing needs to specify the right one. These are the most common.</p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {classes.map((cls, i) => {
            const Icon = cls.icon;
            return (
              <div key={i} data-testid={`tm-class-${i}`} className="group bg-[#093336]/60 backdrop-blur-sm border border-white/5 rounded-2xl p-5 transition-all duration-300 hover:border-[#A5BF23]/30 hover:bg-[#093336]/80 hover:-translate-y-1">
                <div className="flex items-start gap-3">
                  <div className="w-10 h-10 rounded-xl bg-[#A5BF23]/10 flex items-center justify-center flex-shrink-0 group-hover:bg-[#A5BF23]/20 transition-colors">
                    <Icon className="w-5 h-5 text-[#A5BF23]" strokeWidth={1.5} />
                  </div>
                  <div>
                    <span className="text-[10px] font-bold text-[#A0B2B2]/50 tracking-[0.2em]">CLASS {cls.classNum}</span>
                    <h4 className="text-sm font-bold text-[#F0F4F4] mb-0.5" style={{ fontFamily: "'Outfit', sans-serif" }}>{cls.name}</h4>
                    <p className="text-xs text-[#A0B2B2]/70">{cls.examples}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        <p className="text-center text-sm text-[#A0B2B2]/60 mt-10">Unsure about your class? Our attorneys will identify it during consultation.</p>
      </div>
    </section>
  );
};

export default TrademarkClassesSection;
